module.exports = __webpack_public_path__ + "static/media/Broadcast_002.f84ffa77.png";